import { apiClient } from './client';
import type { User } from '../types';

export interface LoginResponse {
  token: string;
  username: string;
  role: string;
  client_id: number;
  // Set when TOTP is required; token is absent in that case.
  mfa_required?: boolean;
  mfa_token?: string;
}

export async function login(username: string, password: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/api/auth/login', {
    username,
    password,
  });
  return data;
}

export async function totpLogin(mfaToken: string, code: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/api/auth/totp/login', {
    mfa_token: mfaToken,
    code,
  });
  return data;
}

export interface TOTPEnrollResponse {
  secret: string;
  otpauth_url: string;
}

export async function totpEnroll(): Promise<TOTPEnrollResponse> {
  const { data } = await apiClient.get<TOTPEnrollResponse>('/api/auth/totp/enroll');
  return data;
}

export async function totpEnable(code: string): Promise<{ backup_codes: string[] }> {
  const { data } = await apiClient.post<{ backup_codes: string[] }>('/api/auth/totp/enable', { code });
  return data;
}

export async function totpDisable(code: string): Promise<void> {
  await apiClient.post('/api/auth/totp/disable', { code });
}

export async function totpRegenerateBackupCodes(code: string): Promise<{ backup_codes: string[] }> {
  const { data } = await apiClient.post<{ backup_codes: string[] }>('/api/auth/totp/backup-codes', { code });
  return data;
}

export async function getMe(): Promise<User> {
  const { data } = await apiClient.get<User>('/api/auth/me');
  return data;
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiClient.put('/api/auth/password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}
